import { InternalAccessor, NavItem, NavItemAccessor } from '@billy/design-system'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { ContactPerson } from '@modules-deprecated/app/contactPerson/types/contactPerson'

import { ContactPersonsTableActionType } from '../enums/contactPersonsTableActionType'
import { ContactPersonsTableRow } from '../types/contactPersonsTable'

export const useContactPersonsTableData = (contactPersons: ContactPerson[]): ContactPersonsTableRow[] => {
  const { t } = useTranslation()

  return useMemo(
    () =>
      contactPersons.map((contactPerson) => {
        const staticActions: NavItem<ContactPersonsTableActionType>[] = [
          {
            children: t('create_invoice'),
            iconLeft: 'fileText',
            id: `${contactPerson.id}-create-invoice`,
            value: ContactPersonsTableActionType.CreateInvoice,
            variant: 'primary',
          },
          {
            children: t('create_quote'),
            iconLeft: 'fileText',
            id: `${contactPerson.id}-create-quote`,
            value: ContactPersonsTableActionType.CreateQuote,
            variant: 'primary',
          },
          {
            accessor: NavItemAccessor.Separator,
            children: null,
            id: `${contactPerson.id}-separator`,
            value: ContactPersonsTableActionType.Edit,
          },
          {
            children: t('contact.detail.contact_persons.actions.edit'),
            iconLeft: 'squarePen',
            id: `${contactPerson.id}-edit`,
            value: ContactPersonsTableActionType.Edit,
            variant: 'primary',
          },
          {
            accessor: NavItemAccessor.Separator,
            children: null,
            id: `${contactPerson.id}-separator-2`,
            value: ContactPersonsTableActionType.Delete,
          },
          {
            children: t('contact.detail.contact_persons.actions.delete'),
            iconLeft: 'trash',
            id: `${contactPerson.id}-delete`,
            value: ContactPersonsTableActionType.Delete,
            variant: 'danger',
          },
        ]

        return {
          ...contactPerson,
          staticActions,
          [InternalAccessor.StaticActions]: true,
        }
      }),
    [contactPersons, t],
  )
}
